import { StepDto } from '@/modules/onboarding/status/domain/dtos';
import { SectionBase } from '@/modules/onboarding/status/domain/services/onboarding-step/step';

export default class PersonalInformation implements SectionBase {
  getStepAndSubStep(): StepDto {
    return {
      step: 4,
      substep: 1,
    };
  }
}
